var YMK = YMK || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.productFoundationVtoV1 = {
    attach: function (context, settings) {
      var $fullProduct = $('.js-product-full', context);
      var $productFoundationVto = $('.js-product-foundation-vto-v1', context);
      var $productVTO = $('.js-product-vto-v1', context);
      var $productImages = $('.js-product-full-media', $productVTO);
      var ykmWidth;
      var ymkHeight;
      var isCr21 = Drupal.settings.globals_variables && Drupal.settings.globals_variables.cr21_spp;
      var iframeHeight = 0;

      if (!$productFoundationVto.length) {
        return;
      }
      var autoTriggerYoucam = window.location.href.indexOf('vto_open') !== -1;
      var hasVtoDiscloseParam = window.location.href.indexOf('vto_disclose') !== -1;
      var showCloseBtn = hasVtoDiscloseParam ? false : true;
      var $foundationVtoButton = $('.js-product-foundation-vto-btn', context);
      var $gnavHeader = $('.js-site-header', context);
      var $foundationVtoContainer = $(
        '.js-product-foundation-vto-container',
        $productFoundationVto
      );
      var $mobileShadePickContainer = $(
        '.js-product-foundation-shade-container',
        $productFoundationVto
      );
      var $mobileShadePicker = $('.js-shade-picker-vto', $productFoundationVto);
      var $addToBagContainer = $('.js-product-vto-cart', $productFoundationVto);
      var $addToBagButton = $('.js-product-add-to-bag', $productFoundationVto);
      var $foundationVtoOverlayContainer = $(
        '.js-foundation-vto-overlay-v1',
        $productFoundationVto
      );
      var $prevCar = $('.js-shades-vto-prev', $productFoundationVto);
      var $nextCar = $('.js-shades-vto-next', $productFoundationVto);
      var $stickyFooter = $('.site-footer', context);

      // overlay elements
      $foundationVtoOverlayContainer.html(site.template.get({ name: 'foundation_vto_overlay' }));
      var $foundationVtoOverlayButton = $(
        '.js-product-foundation-vto-overlay-button',
        $productFoundationVto
      );
      var $foundationVtoIframe = $('.js-product-foundation-vto-iframe', $productFoundationVto);
      var $swatches = $('.js-swatches', $mobileShadePicker);
      var $swatch = $('.js-swatch', $mobileShadePicker);
      var $swatchFilter = $('.js-vto-filter-text', $swatches);
      var $foundationOverlayClose = $(
        '.js-product-foundation-vto-overlay-close',
        $productFoundationVto
      );
      var $foundationVtoOverlayContent = $(
        '.js-product-foundation-vto-overlay-content',
        $productFoundationVto
      );
      var $foundationVtoOverlayGuide = $(
        '.js-product-foundation-vto-overlay-guide',
        $foundationVtoContainer
      );
      var $foundationVtoGuideButton = $('.js-product-foundation-guide', $productFoundationVto);
      var $foundationGuideClose = $(
        '.js-product-foundation-vto-guide-close',
        $productFoundationVto
      );
      var isMob = site.client.isMobile;
      var youcamAPIKey = settings.foundation_vto.api_key;
      var youcamAPIUrl = settings.foundation_vto.api_url;
      var language = settings.foundation_vto.language;
      var splitWindowPosition = settings.foundation_vto.split_window_position || 191;
      var foundationVtoExitPopupPosition =
        settings.foundation_vto.foundation_vto_exit_popup_position;
      var $seeAllshade = $('.js-see-all-foundation-shade', $productFoundationVto);
      var $seeMyPerfect = $('.js-see-perfect', $productFoundationVto);
      var $firstSwatch = $swatches.first();
      var $lastSwatch = $swatches.last();
      var seeAllCopy = $productFoundationVto.attr('data-see-all-copy');
      var shadeCopy = $productFoundationVto.attr('data-shades-copy');
      var shadeCount = $swatches.length;
      var seeAllShadeText = seeAllCopy + ' ' + shadeCount + ' ' + shadeCopy;
      var $bodyElement = $('body', context);
      var foundationResults = [];
      var shadeSelected = false;
      var $swatchContainer;
      var $shadeContainer;
      var youcamEvents = [
        'cameraClosed',
        'cameraFailed',
        'cameraOpened',
        'compare',
        'compareDisabled',
        'closed',
        'engineClosed',
        'loaded',
        'loading',
        'kissDetected',
        'opened',
        'photoLoaded',
        'photoSaved',
        'reset',
        'videoLoaded',
        'shadeFinderStarted',
        'shadeFinderComplete',
        'shadeFinderCancelled',
        'skinShadeFound',
        'zoom',
        'modelLoaded',
        'skinAnalysisUpdated',
        'split4Way',
        'split4WayDisabled'
      ];
      var $qRCode = $('.js-product-full__foundation-qrcode', context);
      // IPhone add to button viewport issue fix.

      if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        iframeHeight = $(window).height();
      }

      site.skuSelect = function (skuData) {
        if (!skuData) {
          return;
        }
        var prodId = skuData.PRODUCT_ID;
        var skuBaseId = skuData.SKU_BASE_ID;
        var prodSelector = "[data-product-id='" + prodId + "']";

        $(prodSelector).trigger('sku:select', skuData);
        $fullProduct.trigger('product.skuSelect', skuBaseId)
        if (!isMob) {
          $fullProduct.trigger('product.updateRoute', skuBaseId);
        }
      };
      (function (d, k) {
        var s = d.createElement('script');

        s.type = 'text/javascript';
        s.async = true;
        s.src = youcamAPIUrl + k;
        var x = d.getElementsByTagName('script')[0];

        x.parentNode.insertBefore(s, x);
      })(document, youcamAPIKey);

      window.ymkAsyncInit = function (skipEventListener) {
        var vtoMatchClass = $('.product__add-to-bag').hasClass('js-add-to-bag');
        var productId = vtoMatchClass
          ? $('.js-add-to-bag').data('product').prodid.replace('PROD', '')
          : $addToBagButton.data('product-id').replace('PROD', '');
        var $vtoModule = $('.js-vto-module', $productVTO);
        var thumbWidth = $productImages.find('.js-product-thumbs:visible').outerWidth(true);
        var slideWidth = $productImages.find('.js-spp-carousel').width();
        var $productFullImages = $('.js-product-full__image', context);
        var vtoParams = {};
        var hasUndertoneSurvey = Drupal.settings.foundation_vto.enable_survey_undertone;
        var hasUndertonePopUp = Drupal.settings.foundation_vto.enable_undertone_popup;
        var undertoneConfig = {};
        var nameHeight = 22;
        var $tmpName = $();
        if (isMob) {
          ykmWidth = $productImages.find('.js-spp-carousel').width();
          ymkHeight = iframeHeight;
        } else {
          if ($productFullImages.length > 1) {
            $productFullImages = $('.js-product-full__image').filter(function (element) {
              return $(element).parents('.js-custom-kit-product').hasClass('active');
            });
          }
          /* Updated the width of SPP, caused the VTO to get an issue of Unsupported width & height
             the content is reduced and centered to fix ASAP. */
          ykmWidth = isCr21 ? $productFullImages.width() - 30 : slideWidth - thumbWidth;
          ymkHeight = isCr21
            ? $('.product-full__carousel-slide').outerHeight(true) * 2
            : $productImages.find('.js-spp-carousel').height();
          if (ymkHeight < ykmWidth && $vtoModule.length && $vtoModule.height()) {
            ymkHeight = $('.js-vto-module').height();
          }
        }
        $productVTO.width(ykmWidth);
        if (hasUndertonePopUp) {
          // Create a tmp duplicate element of the product name
          // in order to get the final height, required for undertone survey
          $tmpName = $('<div />')
            .addClass('tmp-product-name js-tmp-product-name')
            .html(prodcat.data.getProduct('PROD' + productId).PROD_RGN_NAME)
            .appendTo($productFoundationVto);
          nameHeight = $tmpName.height();
          // Remove tmp element after getting the height.
          $tmpName.remove();

          resultsSectionHeight = 190 + nameHeight - 22;
          undertoneConfig = {
            undertoneButtonBottomOffsetY: resultsSectionHeight + 10,
            shadeGuidePageBottomOffsetY: resultsSectionHeight
          };
        }
        vtoParams = {
          autoOpen: false,
          skinSmoothStrength: 17,
          showCloseBtnOnLauncher: showCloseBtn,
          width: ykmWidth,
          height: ymkHeight,
          enableSurveyUndertone: hasUndertoneSurvey,
          enableUserConsent: true,
          ...undertoneConfig
        };
        if (Drupal.settings.foundation_vto.is_product_list_enabled) {
          vtoParams['productIdList'] = [productId];
        }
        if (language) {
          vtoParams['language'] = language;
        }
        if (foundationVtoExitPopupPosition) {
          vtoParams['bottomExitDlgOffsetY'] = foundationVtoExitPopupPosition;
        }
        window.YMK.init(vtoParams);
        if (skipEventListener) {
          return;
        }
        youcamEvents.forEach(function (event) {
          window.YMK.addEventListener(event, function (result, progress) {
            if (event === 'compare' || event === 'compareDisabled') {
              $mobileShadePickContainer.addClass('active');
            } else {
              $mobileShadePickContainer.removeClass('active');
              $swatches.removeClass('vto-filter first-filter active js-best-match best-match');
              $swatchFilter.html('');
            }

            if (event === 'loaded') {
              // add current sku
              if (isMob) {
                toggleMobileShadePick('on');
              }
            }

            if (event === 'opened' && autoTriggerYoucam) {
              $foundationVtoButton.addClass('hidden');
            }

            if (event === 'closed') {
              if (isMob) {
                toggleMobileShadePick('off');
                var skuBaseId = $fullProduct.data('skuBaseId');
                $fullProduct.trigger('product.updateRoute', skuBaseId);
              }
              closeYoucamModule();
            }
            if (event === 'skinShadeFound') {
              if (result.readableRecommendations) {
                foundationResults = result;
                skinShadeFilter();
                $mobileShadePickContainer.addClass('active');
                $seeMyPerfect.removeClass('active');
                if ($mobileShadePicker.find('.vto-filter').length) {
                  $seeAllshade.addClass('active');
                  $swatches.removeClass('active');
                  var $bestShade = $mobileShadePicker.find('.vto-filter.js-best-match .js-swatch');

                  changeSKU($bestShade);
                  var skuBaseId = $bestShade.data('sku-base-id');

                  $fullProduct
                    .trigger('product.skuSelect', skuBaseId)
                  if (!isMob) {
                    $fullProduct.trigger('product.updateRoute', skuBaseId);
                  }
                  $seeAllshade.addClass('active').removeClass('hidden');
                  $seeMyPerfect.addClass('hidden').removeClass('active');
                } else {
                  $seeAllshade.removeClass('active');
                  $swatches.addClass('active');
                  changeSKU($mobileShadePicker.find('.js-swatch').first());
                }
              }
            }
            // MTA-2587 - Analytics tagging for YouCam events - Starts
            var eventName;
            // Supressing multiple event tag fires during loading youcam event
            if (event === 'loading') {
              if (result === 10) {
                eventName = 'loading';
              } else if (result === 100) {
                eventName = 'loaded';
              }
            } else {
              eventName = event;
            }
            if (eventName) {
              trackEvent(eventName);
            }
            // MTA-2587 - Analytics tagging for YouCam events - Ends
          });
        });
        if (autoTriggerYoucam && isMob) {
          openYoucamModule();
        }
      };

      function trackEvent(eventName) {
        if (site && site.track) {
          var productName;
          var skuId;
          var eventLabel;
          var data = site.track.refreshData();
          var selectedSkuId = $swatch.filter('.selected').attr('data-sku-base-id');

          if (
            data &&
            data.product_name &&
            data.product_name.length &&
            data.product_sku &&
            data.product_sku.length &&
            data.product_id &&
            data.product_id.length
          ) {
            productName = data.product_name[0].replace(/(<([^>]+)>)/gi, '');
            skuId = selectedSkuId ? `SKU${selectedSkuId}` : data.product_sku[0];
            eventLabel = `${data.product_id[0]} - ${skuId} - ${productName}`;
          }

          site.track.evtLink({
            event_name: 'vto',
            event_category: 'vto',
            event_action: eventName,
            ...(eventLabel && { event_label: eventLabel }),
            vendor: 'youcam',
            vto_type: 'Foundation'
          });
        }
      }

      function shadeDynamicWidth(width) {
        var $perfectMatchClass = $('.vto-filter');

        if (width && width.length) {
          $perfectMatchClass.css('width', width);
        } else {
          $perfectMatchClass.css('width', '54px');
        }
      }

      function skinShadeFilter() {
        if (
          foundationResults.readableRecommendations &&
          foundationResults.readableRecommendations.length
        ) {
          var currentShadeMatchFound = 0;
          var perfectMatch = foundationResults.readableRecommendations[0];

          if (perfectMatch) {
            $swatches.removeClass('vto-filter first-filter js-best-match best-match');
            var $swatch = $('.js-swatches', $mobileShadePicker);
            var checkClone = $swatch.hasClass('cloned');

            if (checkClone) {
              $swatch.filter('.cloned').remove();
            }
            $.each(perfectMatch, function (skin) {
              var skinData = perfectMatch[skin];

              if ($.isNumeric(skinData)) {
                return;
              }
              var $shadeElement = $mobileShadePicker
                .find('[data-sku-product-code="' + skinData + '"]')
                .closest('.js-swatches');

              if ($shadeElement.length) {
                currentShadeMatchFound = 1;
                var skinText = $productFoundationVto.attr('data-foundation-' + skin);
                var perfectText =
                  skin === 'guid'
                    ? $productFoundationVto.attr('data-foundation-perfect')
                    : skinText;
                var filterClass =
                  skin === 'guid' ? 'js-best-match best-match vto-filter selected' : 'vto-filter';
                var isSameSku = $shadeElement.hasClass('vto-filter');

                if (isSameSku) {
                  var $swatchList = $shadeElement.parent($mobileShadePickContainer);

                  $shadeElement.clone(true).addClass('cloned').appendTo($swatchList);
                  $shadeElement = $('.cloned', $swatchList);
                  $swatchContainer = $shadeElement;
                }
                $shadeElement
                  .addClass(filterClass)
                  .find('.js-vto-filter-text')
                  .html(skinText)
                  .attr('data-filter-text', perfectText);
                if (skin === 'guid') {
                  var $bestMatchSwatch = $shadeElement
                    .find('.swatch__container')
                    .find('.js-swatch');

                  changeSKU($bestMatchSwatch);
                }
              }
            });
            $seeAllshade.html(seeAllShadeText);
            $mobileShadePicker.find('.vto-filter').first().addClass('first-filter');
            var perfectMatchShades = $('.vto-filter').length;

            if (perfectMatchShades) {
              shadeDynamicWidth(100 / perfectMatchShades + '%');
            }
            $prevCar.addClass('hidden');
            $nextCar.addClass('hidden');
          }
          if (currentShadeMatchFound) {
            $seeMyPerfect.addClass('active');
          } else {
            $seeMyPerfect.removeClass('active');
          }
        }
      }

      function openYoucamModule() {
        var $messageIcon = $('#toky_container');
        var $chatLiveButton = $('.LPMcontainer');
        var $slideBagButton = $('.ins-preview-wrapper');
        var $chatLiveIconGadget = $('snappylabs-chat');

        $chatLiveIconGadget.addClass('hidden');
        $gnavHeader.addClass('hidden');
        $messageIcon.addClass('hidden');
        $chatLiveButton.addClass('hidden');
        $slideBagButton.addClass('hidden');
        $stickyFooter.addClass('hidden');
        var $chatLiveIcon = $('.lt-label-chat');

        $chatLiveIcon.addClass('hidden');
        $foundationVtoButton.addClass('hidden');
        $foundationVtoContainer.removeClass('hidden');
        $foundationVtoOverlayContainer.removeClass('hidden');
        if (hasVtoDiscloseParam) {
          $foundationOverlayClose.addClass('hidden');
        }
        $foundationVtoIframe.addClass('hidden');
        autoTriggerYoucam = 0;
        // disable scrolling
        window.scrollTo(0, 0);
        $bodyElement.addClass('no-scroll enable-vto-foundation');
      }

      $foundationVtoButton.once().on('click', function (e) {
        e.preventDefault();
        openYoucamModule();
        $foundationVtoOverlayGuide.hide();
      });

      $foundationVtoOverlayButton.once().on('click', function (e) {
        e.preventDefault();
        var userAgent = navigator.userAgent;
        var iosBrowserErrorCopy = $productFoundationVto.data('ios-browser-error-copy');
        var $overlayContent = $('.js-foundation-vto-overlay-holder', $foundationVtoOverlayContent);
        var $disclaimerCheck = $('.js-vto-disclaimer-checkbox', $foundationVtoOverlayContainer);
        if (
          userAgent.match(/iPhone|iPad/i) &&
          !userAgent.match(/Version\/[\d\.]+.*Safari/) &&
          !(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
        ) {
          if (typeof iosBrowserErrorCopy !== 'undefined') {
            $.colorbox({
              html: iosBrowserErrorCopy,
              width: '300px',
              height: 'auto',
              display: 'inline',
              className: 'vto-ios-browser-error',
              onOpen: function () {
                $('#cboxClose').addClass('icon--remove');
                $overlayContent.hide();
              },
              onClosed: function () {
                $overlayContent.show();
              }
            });
            $('#cboxOverlay').hide();
          }

          return;
        }
        if ($disclaimerCheck.length > 0 && !$disclaimerCheck.is(':checked')) {
          return;
        }
        $foundationVtoOverlayContainer.addClass('hidden');
        $foundationVtoOverlayContent.slideDown('slow');
        $foundationVtoIframe.removeClass('hidden');
        window.YMK.open(true, null, true);
      });

      $foundationVtoGuideButton.once().on('click', function (e) {
        e.preventDefault();
        $foundationVtoOverlayGuide.show();
        $foundationVtoOverlayContent.slideUp('slow');
      });

      function isScrolledIntoViewHorizontal($element, $container) {
        var elementLeft = $element.offset().left;
        var elementRight = elementLeft + $element.outerWidth(true);
        var isVisible =
          elementRight > 1 &&
          Math.ceil(elementRight) < $container.outerWidth(true) + $firstSwatch.outerWidth(true);

        return isVisible;
      }

      $mobileShadePicker.scroll(
        _.debounce(function () {
          var firstInGrid = isScrolledIntoViewHorizontal($firstSwatch, $mobileShadePicker);
          var lastInGrid = isScrolledIntoViewHorizontal($lastSwatch, $mobileShadePicker);
          var fullCarouselLength = $swatches.length * $firstSwatch.outerWidth(true);

          if (fullCarouselLength <= $mobileShadePicker.outerWidth(true)) {
            $nextCar.addClass('hidden');
          } else {
            if (firstInGrid && !lastInGrid) {
              $prevCar.addClass('hidden');
              $nextCar.removeClass('hidden');
            } else if (!firstInGrid && !lastInGrid) {
              $nextCar.removeClass('hidden');
              $prevCar.removeClass('hidden');
            } else if (lastInGrid && !firstInGrid) {
              $nextCar.addClass('hidden');
              $prevCar.removeClass('hidden');
            }
          }
        }, 10)
      );

      $prevCar
        .add($nextCar)
        .once()
        .on('click', function (event) {
          var isShadeNext = $(event.target).hasClass('js-shades-vto-next');
          var carouselWidth = $mobileShadePickContainer.outerWidth(false);
          var position = $swatches.position().left;
          var scrollPosition = isShadeNext ? carouselWidth - position : -position - carouselWidth;

          $mobileShadePicker.animate({
            scrollLeft: scrollPosition
          });
        });

      $seeAllshade.once().on('click', function () {
        $(this).removeClass('active');
        $seeMyPerfect.addClass('active');
        $swatches.addClass('active');
        if ($swatchContainer) {
          $swatchContainer.addClass('active');
        }
        $seeAllshade.addClass('hidden');
        $seeMyPerfect.removeClass('hidden');
        shadeDynamicWidth();
        $mobileShadePicker.scrollTo($mobileShadePicker.find('.marked'), {
          duration: 350,
          offset: -40
        });
        $prevCar.removeClass('hidden');
        $nextCar.removeClass('hidden');
      });

      $seeMyPerfect.once().on('click', function () {
        $(this).removeClass('active');
        $seeAllshade.addClass('active');
        $swatches.removeClass('active');
        if ($swatchContainer) {
          $swatchContainer.removeClass('active');
        }
        $seeMyPerfect.addClass('hidden');
        $seeAllshade.removeClass('hidden');
        var perfectMatchShades = $('.vto-filter').length;

        if (perfectMatchShades) {
          shadeDynamicWidth(100 / perfectMatchShades + '%');
        }
        $prevCar.addClass('hidden');
        $nextCar.addClass('hidden');
        changeSKU($mobileShadePicker.find('.vto-filter.js-best-match .js-swatch'));
      });

      function addChatIcon() {
        var $chatLiveIcon = $('.lt-label-chat');

        $chatLiveIcon.removeClass('hidden');
        var $chatLiveIconGadget = $('snappylabs-chat');

        $chatLiveIconGadget.removeClass('hidden');
      }

      function closeYoucamModule() {
        var $messageIcon = $('#toky_container');
        var $chatLiveButton = $('.LPMcontainer');
        var $slideBagButton = $('.ins-preview-wrapper');

        $seeAllshade.addClass('active').removeClass('hidden');
        $seeMyPerfect.addClass('hidden').removeClass('active');
        $swatches.css('width', '54px');
        $gnavHeader.removeClass('hidden');
        $chatLiveButton.removeClass('hidden');
        $slideBagButton.removeClass('hidden');
        $messageIcon.removeClass('hidden');
        $stickyFooter.removeClass('hidden');
        $foundationVtoContainer.addClass('hidden');
        $foundationVtoButton.removeClass('hidden');
        $swatches.removeClass('vto-filter first-filter selected active js-best-match best-match');
        addChatIcon();
        $swatchFilter.html('');
        if (isMob) {
          // enable scrolling
          $bodyElement.removeClass('no-scroll enable-vto-foundation');
        }
        // reset youcam module
        window.YMK.closeEngine();
        $mobileShadePickContainer.removeClass('active');
        if (hasVtoDiscloseParam) {
          openYoucamModule();
        }
      }

      $foundationOverlayClose.once().on('click', function (e) {
        var $messageIcon = $('#toky_container');
        var $chatLiveButton = $('.LPMcontainer');
        var $slideBagButton = $('.ins-preview-wrapper');

        e.preventDefault();
        $gnavHeader.removeClass('hidden');
        $chatLiveButton.removeClass('hidden');
        $slideBagButton.removeClass('hidden');
        $messageIcon.removeClass('hidden');
        $stickyFooter.removeClass('hidden');
        $bodyElement.removeClass('enable-vto-foundation');
        addChatIcon();
        closeYoucamModule();
      });

      $foundationGuideClose.once().on('click', function (e) {
        e.preventDefault();
        $foundationVtoOverlayContent.slideDown('slow');
      });

      function toggleMobileShadePick(state) {
        if (state === 'on') {
          var $activeSwatch = $mobileShadePicker.find('a.selected');

          $mobileShadePickContainer.removeClass('hidden');
          // scroll to active swatch
          $mobileShadePicker.scrollTo($activeSwatch, {
            duration: 350,
            offset: -40
          });
        } else if (state === 'off') {
          $mobileShadePickContainer.addClass('hidden');
        }
      }

      function changeSKU(swatch) {
        if (
          !page_data ||
          !page_data['consolidated-products'] ||
          !$.isArray(page_data['consolidated-products']['products']) ||
          !swatch.length
        ) {
          return null;
        }
        var skuProductCode = swatch.data('sku-product-code');

        shadeSelected = false;
        var productData = page_data['consolidated-products']['products'][0];
        var skuData = _.find(productData.skus, function (sku) {
          return sku.PRODUCT_CODE === skuProductCode;
        });

        $shadeContainer = swatch.closest('.js-swatches');
        site.skuSelect(skuData);
      }

      $swatches.once().on('click', function () {
        var $this = $(this);
        var skuBaseId = $this.find('a').data('sku-base-id');

        $fullProduct.trigger('product.skuSelect', skuBaseId)
        if (!isMob) {
          $fullProduct.trigger('product.updateRoute', skuBaseId);
        }
      });

      $swatch.once().on('click', function () {
        changeSKU($(this));
      });

      $bodyElement.on('sku:select', function (e, skuData) {
        if (shadeSelected) {
          return;
        }
        // update shadename
        var $shadeNameContainer = $('.js-shadename', $mobileShadePickContainer);
        var $shadePriceContainer = $('.js-shadeprice', $mobileShadePickContainer);
        var $shadeSizeContainer = $('.js-shadesize', $mobileShadePickContainer);
        // update mobile carousel
        var $curMobSwatch;

        if ($shadeContainer) {
          $shadeContainer.parent($mobileShadePicker).find('.marked').removeClass('marked');
          $curMobSwatch = $shadeContainer.find('a[data-sku-base-id="' + skuData.SKU_BASE_ID + '"]');
          $shadeContainer = null;
        } else {
          $curMobSwatch = $mobileShadePickContainer.find(
            'a[data-sku-base-id="' + skuData.SKU_BASE_ID + '"]'
          );
        }
        $mobileShadePickContainer.find('a.js-swatch').removeClass('selected');
        $swatches.removeClass('selected');
        $curMobSwatch.addClass('selected').closest('.swatches--single').addClass('selected');
        $swatches.find('.swatch__container').removeClass('marked');
        $curMobSwatch.siblings('.swatch__container').addClass('marked');
        $shadeNameContainer.html(skuData.SHADENAME).css('color', skuData.HEX_VALUE_STRING);
        $shadePriceContainer.html(skuData.formattedPrice);
        var formattedUnitPrice = skuData.formattedUnitPrice ? ' ' + skuData.formattedUnitPrice : '';

        $shadeSizeContainer.html(skuData.PRODUCT_SIZE + formattedUnitPrice);
        // change the shade
        if (YMK) {
          YMK.applyMakeupBySku(skuData.PRODUCT_CODE);
        }
        if (skuData.VTO_FOUNDATION_ONLINE) {
          $foundationVtoButton.removeClass('hidden');
        } else {
          $foundationVtoButton.addClass('hidden');
        }
        shadeSelected = true;
      });
      $(document).on('change', '.js-vto-disclaimer-checkbox', function (e) {
        var isDisclaimerChecked = $(e.target).is(':checked');
        $foundationVtoOverlayButton.toggleClass('disabled', !isDisclaimerChecked);
      });
      $(document).on('open_vto', function () {
        openYoucamModule();
        $foundationVtoOverlayGuide.hide();
      });
      $(document).bind('addToCart.success', function () {
        var addedText = $addToBagContainer.attr('data-added-text');
        var atbText = $addToBagButton.html();

        $addToBagButton.html(addedText);
        setTimeout(function () {
          $addToBagButton.html(atbText);
        }, 3000);
      });
      window.GlobalServiceBus?.on(window.ServiceBusTopics.events.VTO_FOUNDATION_QR_CODE_OVERLAY_CLOSED, function() {
        $qRCode.addClass('hidden');
      });
      $('.js-product-foundation-vto-btn--desktop', document).once().on('click', function (event) {
        event.preventDefault;
        var labelText = $(this).text().trim();
        var eventAction = labelText ? labelText : 'cta_click';

        trackEvent(eventAction);
        $qRCode.removeClass('hidden');
      });
    }
  };
})(jQuery);
